{
  "backButton": "Späť na {prevMenuButton}",
  "moreActions": "Ďalšie akcie",
  "unavailable": "Nedostupné, rozbaľte podrobnosti"
}
